exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".pe-pagination button{min-width:44px;min-height:44px;padding:0;color:#6a7070;background-color:transparent;border:0}.pe-pagination button:not([disabled]){cursor:pointer}.pe-pagination button.ellipsis{min-width:32px}.pe-pagination button:focus span,.pe-pagination button:hover span{border-bottom:2px solid #6a7070}.pe-pagination button[aria-current] span{color:#252525;border-bottom:2px solid #252525;font-weight:700}.pe-pagination button:first-child,.pe-pagination button:last-child{min-width:28px;min-height:28px;border:1px solid #c7c7c7;border-radius:50%}.pe-pagination button:first-child:focus span,.pe-pagination button:first-child:hover span,.pe-pagination button:last-child:focus span,.pe-pagination button:last-child:hover span{border-bottom:0}.pe-pagination button:first-child:disabled,.pe-pagination button:last-child:disabled{color:#c7c7c7}.pe-pagination .compact-text{margin:0 17px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/lib/loader.js!./src/scss/pagination.scss
// module id = ./node_modules/css-loader/index.js!./node_modules/sass-loader/lib/loader.js!./src/scss/pagination.scss
// module chunks = 0 1 2